module.exports = __webpack_public_path__ + "static/media/Mandurah-mobile.0e09543e.jpg";